<template>
  <div :class="['editor-detail-about-skeleton', { _mobile: isMobile }]">
    <div class="editor-detail-about-skeleton__title"></div>
    <div class="editor-detail-about-skeleton__description">
      <div class="editor-detail-about-skeleton__line"></div>
      <div class="editor-detail-about-skeleton__line"></div>
      <div class="editor-detail-about-skeleton__line _short"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
const isMobile: boolean = useIsMobile();
</script>

<style lang="less">
.editor-detail-about-skeleton {
  .flex-column(@size-x6);
  .box-shadow();

  padding: @size-x8;
  border-radius: @main-size;

  &__title {
    .skeleton(180px, 39px);
  }

  &__description {
    .flex-column(@size-x4);
  }

  &__line {
    .skeleton(100%, 21px);

    &._short {
      width: 70%;
    }
  }

  &._mobile {
    padding: @size-x6;
  }

  &._mobile &__title {
    width: 150px;
    height: 30px;
  }
}
</style>
